import React, { useMemo, useState } from 'react';
import styled from 'styled-components';
import { Film } from 'react-feather';

import { isVideoPlayable } from '../../../../lib/mime';

const VideoContainer = styled.div<{ height: number }>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${({ height }) => height}px;
  width: ${({ height }) => 2 * height}px;
  background-color: black;
  cursor: pointer;
`;

export interface VideoProps {
  mime: string;
  url: string;
  height: number;
}

export const Video = ({ mime, url, height }: VideoProps) => {
  /**
   * isVideoPlayable runs every time mime or url is updated.
   * If the result is a boolean we set the state to that value and never update it.
   * If the result is a promise the state goes from Promise<boolean> -> boolean when
   * the promise resolves.
   */
  const [isPlayable, setIsPlayable] = useState(useMemo(() => {
    const retval = isVideoPlayable(mime, url);
    if (retval instanceof Promise) {
      retval.then((value) => setIsPlayable(value));
    }
    return retval;
  }, [mime, url]));

  return isPlayable === true ? (
    // eslint-disable-next-line jsx-a11y/media-has-caption
    <video height={height} controls playsInline>
      <source src={url} type={mime} />
      <a target="_blank" rel="noreferrer" href={url}>
        {`Download Video attachment: ${url.split('/').pop()}`}
      </a>
    </video>
  ) : (
    <VideoContainer height={height} onClick={() => window.open(url)}>
      <Film color="white" size={height / 2} />
    </VideoContainer>
  );
};
